import { useEffect, useState, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import {
  dismissAppErrorModal,
  subscribeAppErrorModal,
  type AppErrorModalRequest,
} from './appErrorModal'
import { ErrorModal } from './ErrorModal'

export function ErrorModalProvider({ children }: { children: ReactNode }) {
  const [active, setActive] = useState<AppErrorModalRequest | null>(null)

  useEffect(() => {
    return subscribeAppErrorModal(setActive)
  }, [])

  const dismiss = () => {
    dismissAppErrorModal()
  }

  return (
    <>
      {children}
      {active
        ? createPortal(
            <ErrorModal
              title={active.title}
              message={active.message}
              messageNode={active.messageNode}
              onDismiss={dismiss}
            />,
            document.body,
          )
        : null}
    </>
  )
}
